import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  SuccessResponse,
  X1Language,
  X1LanguageUpdateModel
} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class EditLanguageStore implements SaveStateHolder {
  readonly languageId: number;

  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly language: X1Language) {
    makeObservable(this);
    this.languageId = language.Id;
    this.name = new StringControl('name', language.Name, validators.required);
    this.save = null;
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;

    const model: X1LanguageUpdateModel = {
      Index: this.language.Index,
      Name: this.name.value
    };
    this.save = contentLoaders.x1language.update(this.language.Id, model);
  };
}
